<template>
  <div class="section-main__warp account-wrap">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @open-add="openSuccess"
      @close-callback="closeDialog"
      @row-save="submitForm"
      @search-change="searchList"
      @search-reset="searchRest"
      @size-change="handleSizeChange"
    >
      <template slot="roleForm">
        <div class="flex-row">
          <div class="draw-device-list-area">
            <div class="flex-between valign-center list-title">
              <div>已选择{{cameraList.length}}个</div>
              <div class="add-device-btn" @click="showTree">+</div>
            </div>
            <div class="device-list">
              <div
                class="device-item"
                v-for="(item,index) in cameraList"
                :class="{bg:index==isactive}"
                :key="item.deviceId"
                @click="getEquipment(item,index)"
              >{{item.deviceName}}</div>
            </div>
          </div>
          <div class="draw-device-area">
            <div class="map_container">
              <div class="map_operator" v-if="currentoperator">
                <el-button @click="startdraw" v-if="drawFlag == '1'" type="text" size="medium">
                  {{$t('task.label.selection')}}
                </el-button>
                <el-button @click="startdraw" v-if="drawFlag=='2'" type="text" size="medium">
                  {{$t('task.label.resetSelection')}}
                </el-button>
              </div>
              <div class="video-content" id="ocxPlayer">
                <videojs-player ref="player" :windowNumber="windowNumber" :playOption="playOption"></videojs-player>
              </div>
              <video-draw-polygon class="drawArea" ref="videoDraw" :size="drawSize"></video-draw-polygon>
              <!-- <canvas id="canvas" class="drawArea" width="384" height="216"></canvas> -->
              <div id="Popuplayer" v-show="popFlag"></div>
            </div>
          </div>
        </div>
      </template>
      <template slot="roleView">
        <div class="flex-row">
          <div class="draw-device-list-area">
            <div class="flex-between valign-center list-title">
              <div>摄像机列表</div>
            </div>
            <div class="device-list">
              <div
                class="device-item"
                v-for="(item,index) in cameraDetailList"
                :class="{bg:index==isactiveDetail}"
                :key="item.deviceId"
                @click="getEquipmentDetalis(item,index)"
              >{{item.deviceName}}</div>
            </div>
          </div>
          <div class="draw-device-area">
            <div class="map_container">
              <div class="map_operator" v-if="currentoperator">
                <span>周界范围</span>
              </div>
              <div class="video-content" id="ocxPlayer">
                <videojs-player ref="player" :windowNumber="windowNumber" :playOption="playOption"></videojs-player>
              </div>
              <canvas id="canvas" class="drawArea" width="384" height="216"></canvas>
              <div id="Popuplayer" v-show="popFlag"></div>
            </div>
          </div>
        </div>
      </template>
      <template slot="menuLeft">
        <el-button
          v-auth="'/account/index:add'"
          type="primary"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAddAccount"
        >新增</el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            v-auth="'/account/index:query'"
            type="text"
            @click="viewData(scope.row)"
            icon="iconfont icon-Detail"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            v-auth="'/account/index:delete'"
            type="text"
            @click="deleteData(scope.row)"
            icon="iconfont icon-shanchu"
          ></el-button>
        </el-tooltip>
      </template>
      <template slot="status" slot-scope="scope">
        <el-switch
          v-auth="'/account/index:startStop'"
          v-model="scope.row.status"
          :disabled="scope.row.status === 3"
          :active-value="1"
          :inactive-value="scope.row.status == 3 ? 3 : 2"
          @change="handleUpdateStatus(scope.row)"
        ></el-switch>
        {{ scope.row.$status }}
      </template>
    </ioc-table>
    <!-- 区域树 -->
    <el-dialog title="区域设备树" :visible.sync="showTreeList" v-dialogDrag width="350px">
      <area-device-tree ref="deviceTree" @handleCollection="openCollection" :multiCheck="true"></area-device-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDeviceTree">取 消</el-button>
        <el-button type="primary" @click="confirmDevices">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableOption from "../options/table";
import utils from '@src/common/utils'
// 区域设备树
import areaDeviceTree from "@src/components/common/app-area-list";
import VideojsPlayer from "@src/components/common/media-player/videojs-player.vue";
import mediaPlayer from "@src/modules/video/components/realTime/Window.vue";
import videoDrawPolygon from '@src/components/business/video/video-draw-polygon.vue'
export default {
  name: "perimeter",
  components: { areaDeviceTree, VideojsPlayer, videoDrawPolygon },
  data() {
    return {
      playOption: {
        videoSrc:
          "http://nebula-playback.qiniudn.com/test-playback/flv/sample.flv",
        deviceId: "1",
        cameraType: "",
        playId: "1000",
        posterSrc: "/images/theme/newDark/default.png",
      },
      windowNumber: 1,
      isactiveDetail: null,
      isactive: null,
      dialogType: "1",
      showTreeList: false,
      cameraCount: 0,
      cameraDataList: null,
      cameraDetailList: [],
      cameraList: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      option: tableOption(this),
      tableData: [],
      form: {
        sendImgQuality: "0",
        personThreadHold: "1",
        durationThreadhold: "30",
        cameraId: "beffc536-9f8d-4b3a-8a35-7cc184f9f375",
        areaSetting: "Polygon 0 0 0 0",
        iconQuality: "open",
      },
      labelPosition: "right",
      labelWidth: "110px",
      selectList: [
        {
          value: "open",
          label: "开启",
        },
        {
          value: "close",
          label: "关闭",
        },
      ],
      qualityList: [
        {
          value: "0",
          label: "低",
        },
        {
          value: "1",
          label: "中",
        },
        {
          value: "2",
          label: "高",
        },
      ],
      canvasShow: true,
      popFlag: true,
      isPlaying: false,
      cancelbtn: true,
      resetFlag: true,
      currentoperator: true,
      drawFlag: 1,
      intrusionArea: [],
      currentcameraflag: false,
      taskConfig: [],
      cameraLine: [],
      arr: [],
      arr1: [],
      arr2: [],
      arr3: [],
      arr4: [],
      canvas: null,
      cxt: {},
      devices: [],
      type: "1",
      copyAry: [
        {
          x: 86,
          y: 94,
        },
        {
          x: 245,
          y: 134,
        },
        {
          x: 316,
          y: 110,
        },
      ],
      drawSize: {
        width: 384,
        height: 216
      }
    };
  },
  mounted() {
    this.searchRest();
  },
  methods: {
    searchRest() {
      let params = {
        pageSize: 10,
        pageNum: 1,
      };
      this.$fetch(
        "/vas/intrusionTask/queryIntrusionTaskList.json",
        params
      ).then((res) => {
        console.log("res", res);
        this.tableData = (res.returnObj && res.returnObj.list) || [];
        this.page.total = (res.returnObj && res.returnObj.total) || 0;
      });
    },
    //播放視頻
    handlePlay(thirdAlarmDevId) {
      console.log("thirdAlarmDevId", thirdAlarmDevId);
      this.playOption.deviceId = thirdAlarmDevId;
      this.playOption.playType = "live";
      this.$refs.player.playLiveVideo({
        thirdCameraId: thirdAlarmDevId,
      });
    },
    handleSizeChange(val) {
      console.log("val", val);
      // this.page.pageSize = val;
      let params = {
        pageSize: val,
        pageNum: 1,
      };
      this.$fetch(
        "/vas/intrusionTask/queryIntrusionTaskList.json",
        params
      ).then((res) => {
        this.tableData = (res.returnObj && res.returnObj.list) || [];
        this.page.total = (res.returnObj && res.returnObj.total) || 0;
      });
    },
    searchList(data) {
      data.pageSize = 10;
      data.pageNum = 1;
      this.$fetch("/vas/intrusionTask/queryIntrusionTaskList.json", data).then(
        (res) => {
          this.tableData = (res.returnObj && res.returnObj.list) || [];
        }
      );
    },
    getEquipmentDetalis(item, index) {
      this.isactiveDetail = index;
      this.handlePlay(item.thirdDeviceId);
      if (!this.canvas) {
        this.init();
      }
      this.reClean();
      if (item.areaSetting.polygons && item.areaSetting.polygons.length > 0) {
        //回填面積
        let ary = [];
        item.areaSetting.polygons.map((val) => {
          val.data.map((_data) => {
            ary.push({
              x: _data[0],
              y: _data[1],
            });
          });
        });
        this.drawPolygon(this.cxt, ary, 2, "red", "rgba(222, 0, 0, .1)", true);
      } else if (item.areaSetting.lines && item.areaSetting.lines.length > 0) {
        let ary = [];
        item.areaSetting.lines.map((val) => {
          val.data.map((_data) => {
            ary.push({
              x: _data[0],
              y: _data[1],
            });
          });
        });
        this.drawPolygon(this.cxt, ary, 1, "red");
      }
    },
    viewData(item) {
      let params = {
        taskCode: item.taskCode,
      };
      this.$fetch(
        "/vas/intrusionTask/queryIntrusionTaskDetail.json",
        params
      ).then((res) => {
        this.cameraDetailList = res.returnObj.cameraList;
      });
      this.dialogType = "2";
      this.isactive = 0;
      this.$refs.crud.rowView(item);
    },
    deleteData(item) {
      this.$confirm(`确定要删除此任务吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            taskCode: item.taskCode,
          };
          this.$fetch(
            "/vas/intrusionTask/deleteIntrusionTask.json",
            params
          ).then((res) => {
            if (res.success === true) {
              this.$message({
                showClose: false,
                message: `任务刪除成功`,
                type: "success",
                duration: 2000,
              });
              this.searchRest();
            } else {
              this.$message({
                showClose: false,
                message: res.msgContent,
                type: "warning",
                duration: 2000,
              });
            }
          });
        })
        .catch(() => {
          if (row.status == 1) {
            row.status = 2;
          } else if (row.status == 2) {
            row.status = 1;
          }
          this.$message({
            type: "success",
            message: "取消成功！",
            duration: 2000,
          });
        });
    },
    closeDialog() {
      // console.log('dialogType',this.dialogType)
      // console.log('canvas',this.canvas)
      if (this.dialogType == "2") {
        if (this.canvas) {
          this.isactiveDetail = null;
          this.reClean(true);
        }
      } else {
        // this.isactive = null
        this.cameraList = [];
      }
    },
    closeDeviceTree() {
      this.showTreeList = false;
    },
    confirmDevices() {
      let data = this.$refs.deviceTree.getCheckedNodes().device || [];
      this.cameraList = [];
      data.map((val) => {
        this.cameraList.push({
          deviceId: val.id,
          deviceName: val.name,
          thirdDeviceId: val.thirdCameraId,
          areaSetting: {
            polygons: [],
            lines: [],
          },
        });
      });
      this.closeDeviceTree();
    },
    cameraData(data) {
      this.cameraList = [];
      data.map((val) => {
        this.cameraList.push({
          deviceId: val.id,
          deviceName: val.name,
          thirdDeviceId: val.thirdCameraId,
          areaSetting: {
            polygons: [],
            lines: [],
          },
        });
      });
      // console.log("cameraList", this.cameraList);
    },
    openCollection(item) {
      console.log("item", item);
    },
    deviceClickTree(item) {
      console.log("item", item);
    },
    chooseDevice(item) {
      console.log("item", item);
    },
    showTree() {
      this.showTreeList = true;
    },
    openSuccess() {
      // this.reClean()
      // this.drawFlag = 1;
      // this.init();
    },
    init() {
      this.canvas = document.getElementById("canvas");
      this.cxt = this.canvas.getContext("2d");
      this.cxt.translate(0, 0);
      this.popFlag = false;
      this.reClean();
      if (!this.currentcameraflag) {
        this.canvasShow = true;
        this.cancelbtn = true;
        let _this = this;
        var x, y;
        (this.canvas.onclick = (e) => {
          x = e.offsetX;
          y = e.offsetY;
          if (this.arr.length >= 3) {
            this.arr.push({
              x,
              y,
            });
          }
          this.arr.length < 3
            ? this.arr.push({
                x,
                y,
              })
            : null;
          _this.drawPolygon(this.cxt, this.arr, 1, "blue");
          this.arr1 = [x, y];
          this.arr2.push(this.arr1);
        }),
          (this.canvas.ondblclick = () => {
            if (this.arr.length > 2) {
              this.arr.splice(this.arr.length - 2, 1);
              this.arr2.splice(this.arr2.length - 2, 1);
              if (this.arr2.length == 2) {
                let line = this.arr2[0][0];
                console.log("line", line);
              }
              this.arr2.push(this.arr2[0]);
              this.arr3.push(this.arr2);
              _this.drawPolygon(
                this.cxt,
                this.arr,
                2,
                "red",
                "rgba(222, 0, 0, .1)",
                true
              );
              this.arr1 = [];
              this.arr2 = [];
              this.arr3 = [];
              this.arr = [];
              _this.cxt.closePath();
              this.arr4 = this.arr3.toString();
              this.intrusionArea.push(this.arr4);
            }
          });
      }
    },
    getEquipment(item, index) {
      console.log("item", item);
      this.handlePlay(item.thirdDeviceId);
      this.isactive = index;
      if (!this.canvas) {
        this.drawFlag = 1;
        this.init();
      }
      this.reClean(true);
      this.cameraDataList = item;
      if (item.areaSetting) {
        //回填
        if (item.areaSetting.polygons.length > 0) {
          //回填面積
          let ary = [];
          item.areaSetting.polygons.map((val) => {
            val.data.map((_data) => {
              ary.push({
                x: _data[0],
                y: _data[1],
              });
            });
          });
          this.drawPolygon(
            this.cxt,
            ary,
            2,
            "red",
            "rgba(222, 0, 0, .1)",
            true
          );
        }
        if (item.areaSetting.lines.length > 0) {
          let ary = [];
          item.areaSetting.lines.map((val) => {
            val.data.map((_data) => {
              ary.push({
                x: _data[0],
                y: _data[1],
              });
            });
          });
          this.drawPolygon(this.cxt, ary, 1, "red");
        }
      }
    },
    handleAddAccount() {
      this.dialogType = "1";
      this.$refs.crud.rowAdd();
    },
    handleUpdateStatus(row) {
      console.log("rowrowrow", row);
      this.$confirm(
        `确定要${row.status === 1 ? "启用" : "禁用"}此任务吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            taskCode: row.taskCode,
            status: row.status,
          };
          if (row.status == 1) {
            this.$fetch(
              "/vas/intrusionTask/activeIntrusionTask.json",
              params
            ).then((res) => {
              console.log("res", res);
              if (res.success) {
                this.$message({
                  showClose: false,
                  message: `任务${row.status === 1 ? "启用" : "禁用"}成功`,
                  type: "success",
                  duration: 2000,
                });
              }
            });
          } else {
            this.$fetch(
              "/vas/intrusionTask/suspendIntrusionTask.json",
              params
            ).then((res) => {
              console.log("res", res);
              if (res.success) {
                this.$message({
                  showClose: false,
                  message: `任务${row.status === 1 ? "启用" : "禁用"}成功`,
                  type: "success",
                  duration: 2000,
                });
              }
            });
          }
        })
        .catch(() => {
          if (row.status == 1) {
            row.status = 2;
          } else if (row.status == 2) {
            row.status = 1;
          }
          this.$message({
            type: "success",
            message: "取消成功！",
            duration: 2000,
          });
        });
    },
    handleCreate() {},
    getCameras(data) {
      if (data.length) {
        this.devices = data.map((item) => {
          return {
            deviceId: item.thirdCameraId,
            deviceName: item.name,
            thirdDeviceId: item.thirdCameraId,
            thirdDeviceName: item.name,
            id: item.id,
          };
        });
      } else {
        this.devices = [];
      }
      console.warn("====", this.devices);
    },
    deviceChoose(nodeData) {
      const param = {
        deviceID: nodeData.deviceId || nodeData.id,
        endTime: "",
        service: 5,
        startTime: "",
      };
      this.$fetch("/vas/video/queryCameraHtmlLiveUrl.json", param).then(
        (res) => {
          console.log("-------------------------", res);
          if (res.success) {
            this.isPlaying = true;
            this.$refs.saasVideo.playLiveByUrl(res.returnObj);
          }
        }
      );
    },
    deviceClick(nodeData) {
      if (nodeData && nodeData.thirdDeviceId) {
        this.form.cameraId = nodeData.thirdDeviceId;
      }
    },
    submitForm(data) {
      // console.log('submit',data)
      console.log("submit", this.cameraList);
      let copyCameraList = JSON.parse(JSON.stringify(this.cameraList));
      copyCameraList.map((val) => {
        if (val.areaSetting.polygons.length == 0) {
          delete val.areaSetting.polygons;
        }
        if (val.areaSetting.lines.length == 0) {
          console.log("lines==0");
          delete val.areaSetting.lines;
        }
      });
      data.cameraList = copyCameraList;
      console.log("submit", data);
      this.$fetch("/vas/intrusionTask/addIntrusionTask.json", data).then(
        (res) => {
          if (res.success) {
            this.$message.success("新增成功");
            this.$refs.crud.closeAdd();
            this.searchRest();
            console.log("res", res);
          } else {
            this.$message.error(res.msgContent || '新增视频周界任务失败');
          }
        }
      );
    },
    selectIconQuality() {},
    startdraw() {
      // console.log("this.canvas", this.canvas);
      // this.canvas = document.getElementById("canvas");
      // this.cxt = this.canvas.getContext("2d");
      // this.cxt.translate(0, 0);
      // this.popFlag = false;
      this.reClean();
    },
    drawPoint(cxt, x, y, w, borderWidth, borderColor, fillColor) {
      this.cxt.beginPath();
      this.cxt.moveTo(x - w, y - w);
      this.cxt.lineTo(x + w, y - w);
      this.cxt.lineTo(x + w, y + w);
      this.cxt.lineTo(x - w, y + w);
      this.cxt.lineWidth = borderWidth;
      this.cxt.strokeStyle = borderColor;
      this.cxt.fillStyle = fillColor;
      this.cxt.closePath();
      this.cxt.fill();
      this.cxt.stroke();
      this.drawcomplete();
    },
    drawPolygon(cxt, dbl, borderWidth, borderColor, fillColor, t) {
      // console.log("dbl", dbl);
      let _this = this;
      for (let i = 0; i < dbl.length; i++) {
        _this.drawPoint(cxt, dbl[i].x, dbl[i].y, 2, 1, "red", "skyblue");
      }
      this.cxt.moveTo(dbl[0].x, dbl[0].y);
      for (let j = 1; j < dbl.length; j++) {
        this.cxt.lineTo(dbl[j].x, dbl[j].y);
      }
      if (t) {
        this.cxt.closePath();
        this.cxt.fillStyle = fillColor;
        this.cxt.fill();
      }
      this.cxt.lineWidth = borderWidth;
      this.cxt.strokeStyle = borderColor;
      this.cxt.stroke();
    },
    drawPolygonItem(cxt, dbl, borderWidth, borderColor, fillColor, t) {
      let _this = this;
      for (let i = 0; i < dbl.length; i++) {
        _this.drawPoint(cxt, dbl[i][0], dbl[i][1], 2, 1, "red", "skyblue");
      }
      this.cxt.moveTo(dbl[0].x, dbl[0].y);
      for (let j = 1; j < dbl.length; j++) {
        this.cxt.lineTo(dbl[j][0], dbl[j][1]);
      }
      if (t) {
        this.cxt.closePath();
        this.cxt.fillStyle = fillColor;
        this.cxt.fill();
      }
      this.cxt.lineWidth = borderWidth;
      this.cxt.strokeStyle = borderColor;
      this.cxt.stroke();
    },
    z(x, y, x1, y1, x2, y2) {
      if ((x - x1) * (y2 - y1) - (y - y1) * (x2 - x1) > 0) {
        return 1;
      } else if ((x - x1) * (y2 - y1) - (y - y1) * (x2 - x1) < 0) {
        return 3;
      } else {
        return 2;
      }
    },
    //绘制完成
    drawcomplete() {
      let dataList = [];
      this.currentcameraflag = true;
      this.cancelbtn = false;
      this.canvasShow = true;
      this.popFlag = true;
      this.resetFlag = false;
      // this.arr3[0].map((val,index)=>{
      //   console.log('val',this.arr3.length)
      //   if (index!=this.arr3.length-1) {
      //     dataList.push(val)
      //   }
      // })
      this.arr3.map((val) => {
        val.map((item, index) => {
          // console.log("item", item);
          if (index != val.length - 1) {
            dataList.push(item);
          }
        });
      });
      if (this.arr3 && this.arr3.length > 0) {
        let lineList = [];
        let areaList = [];
        if (dataList.length > 2) {
          areaList = dataList;
        } else {
          lineList = dataList;
        }
        // console.log("areaList", areaList);
        // console.log("lineList", lineList);
        if (dataList.length > 2) {
          // console.log("this.cameraData", this.cameraData);
          // console.log("this.cameraList", this.cameraList);
          this.cameraList.map((val) => {
            if (this.cameraDataList.deviceId == val.deviceId) {
              console.log("val.areaSetting.polygons", val.areaSetting.polygons);
              if (val.areaSetting.polygons.length == 0) {
                val.areaSetting.polygons.push({
                  data: areaList,
                });
              } else {
                let area_return = val.areaSetting.polygons.find((item) => {
                  return item.data.toString() == areaList.toString();
                });
                if (!area_return) {
                  val.areaSetting.polygons.push({
                    data: areaList,
                  });
                }
              }
            }
          });
        }
        if (dataList.length == 2) {
          this.cameraList.map((val) => {
            if (this.cameraDataList.deviceId == val.deviceId) {
              if (val.areaSetting.lines.length == 0) {
                val.areaSetting.lines.push({
                  data: lineList,
                });
              } else {
                let lines_return = val.areaSetting.lines.find((item) => {
                  return item.data.toString() == lineList.toString();
                });
                if (!lines_return) {
                  val.areaSetting.lines.push({
                    data: lineList,
                  });
                }
              }
            }
          });
        }
        let flag = false;
        this.drawFlag = 2;
      }
    },
    clearUp() {
      this.cancelbtn = false;
      this.canvasShow = false;
      if (this.arr.length > 2) {
        this.drawPolygon(
          this.cxt,
          this.arr,
          1,
          "red",
          "rgba(0,  0, 0, .1)",
          true
        );
        // 这里执行完成闭合之后，清空坐标数组，便于另外新建
        this.arr = [];
        this.cxt.closePath();
      }
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.dbl = [];
      this.arr = [];
      this.cxt.closePath();
      this.cxt.stroke();
      this.canvas.width = this.canvas.width;
      this.currentcameraflag = false;
      if (this.taskConfig && this.taskConfig.length > 0) {
        for (let i = 0; i < this.taskConfig.length; i++) {
          if (this.taskConfig[i].cameraId == this.selectedCameraId) {
            this.taskConfig.splice(i, 1);
          }
        }
      }
      let param = {
        cameraId: this.selectedCameraId,
        targetType: this.targetType,
      };
      this.taskConfig.push(param);
      if (this.cameraLine && this.cameraLine.length > 0) {
        for (let i = 0; i < this.cameraLine.length; i++) {
          if (this.cameraLine[i].cameraId == this.selectedCameraId) {
            this.cameraLine.splice(i, 1);
          }
        }
      }
      let cameraLineParam = {
        cameraId: this.selectedCameraId,
      };
      this.cameraLine.push(cameraLineParam);
    },
    clean() {
      this.resetFlag = true;
      if (this.arr.length > 2) {
        this.drawPolygon(
          this.cxt,
          this.arr,
          1,
          "red",
          "rgba(0,  0, 0, .1)",
          true
        );
        // 这里执行完成闭合之后，清空坐标数组，便于另外新建
        this.arr = [];
        this.cxt.closePath();
      }
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.dbl = [];
      this.arr = [];
      this.cxt.closePath();
      this.cxt.stroke();
      this.canvas.width = this.canvas.width;
      this.currentcameraflag = true;
    },
    reClean(type) {
      if (!type) {
        if (this.cameraDataList) {
          this.cameraList.map((val) => {
            if (val.deviceId == this.cameraDataList.deviceId) {
              val.areaSetting.polygons = [];
              val.areaSetting.lines = [];
            }
          });
          this.cameraDataList.areaSetting.polygons = [];
          this.cameraDataList.areaSetting.lines = [];
        }
      }
      // console.log("this.cameraList", this.cameraList);
      // if (this.arr.length > 2) {
      //   this.drawPolygon(
      //     this.cxt,
      //     this.arr,
      //     1,
      //     "red",
      //     "rgba(0,  0, 0, .1)",
      //     true
      //   );
      //   // 这里执行完成闭合之后，清空坐标数组，便于另外新建
      //   this.arr = [];
      //   this.cxt.closePath();
      // }
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.dbl = [];
      this.arr = [];
      this.cxt.closePath();
      this.cxt.stroke();
      this.canvas.width = this.canvas.width;
    },
    closeDeviceList() {
      this.$refs.saasVideo.stopLive();
      this.$emit("closeDeviceList");
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.app-area-list .area-container {
  height: 300px;
  overflow: auto;
}
.filter_actions {
  display: none;
}
.draw-device-list-area {
  flex: 1;
  margin-right: 15px;
  .list-title {
    @include set_theme_color(color, font-default-color);
    @include set_theme_color(background-color, table-header-bg-color);
    height: 40px;
    padding: 0 10px;
  }
  .add-device-btn {
    @include set_theme_color(background-color, main-theme-color);
    @include set_theme_color(color, font-default-color);
    height: 23px;
    line-height: 23px;
    width: 23px;
    text-align: center;
    cursor: pointer;

    &:hover {
      @include set_theme_color(background-color, active-border-color);
    }
  }
  .device-list {
    overflow: auto;
    height: 216px;
    @include set_theme_color(background-color, menu-tab-bg-color);
  }

  .device-item {
    padding: 5px 10px;
    cursor: pointer;
    @include set_theme_color(background-color, table-odd-line-bg-color);

    &:nth-child(odd) {
      @include set_theme_color(background-color, content-bg-color);
    }

    &:hover {
      @include set_theme_color(background-color, item-active-bg-color);
    }
  }
}
.draw-device-area {
  width: 384px;
  position: relative;
}
.video-content {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 216px;
}
.map_container {
  @include set_theme_color(background-color, table-header-bg-color);
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.map_container_transparent {
  background: transparent;
}
.map_op_icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.map_operator {
  @include set_theme_color(color, font-default-color);
}
.drawArea {
  position: absolute;
  top: 40px;
  left: 0;
}
.bg {
  color: blue;
}
</style>